import Dashboard from "./pages/Dashboard";
import { Navigate, RouteObject } from "react-router-dom";
import ManageAccountPage from "./pages/account/ManageAccount";
import SiteEditLayout from "./components/Layouts/SiteEditLayout";
import SiteDashboard from "./pages/site";
import EditSiteScreen from "./pages/site/edit";
import PagesIndexScreen from "./pages/site/pages";
import PagesEditScreen from "./pages/site/pages/edit";
import SiteSettingsLayout from "./pages/site/settings/layout";
import SiteSettingsIndex from "./pages/site/settings/page";
import SiteSettingsUrlsPage from "./pages/site/settings/urls/page";
import SiteSettingsTransferSitePage from "./pages/site/settings/transfer/page";
import SiteSettingsThemeScreen from "./pages/site/settings/theme/page";
import SiteSettingsMenuPage from "./pages/site/settings/menu/page";
import SiteSettingsFontsAndColorsPage from "./pages/site/settings/fonts-and-colors/page";
import SiteSettingsDeleteSitePage from "./pages/site/settings/delete/page";
import SiteSettingsAdvancedPage from "./pages/site/settings/advanced/page";

export const authenticatedRoutes: RouteObject[] = [
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/:siteId/",
    element: <SiteEditLayout />,
    children: [
      {
        index: true,
        element: <SiteDashboard />,
      },
      {
        path: "edit",
        element: <EditSiteScreen />,
      },
      {
        path: "pages",
        element: <PagesIndexScreen />,
      },
      {
        path: "pages/:pageId",
        element: <PagesEditScreen />,
      },
      {
        path: "settings",
        element: <SiteSettingsLayout />,
        children: [
          {
            index: true,
            element: <SiteSettingsIndex />,
          },
          {
            path: "urls",
            element: <SiteSettingsUrlsPage />,
          },
          {
            path: "transfer",
            element: <SiteSettingsTransferSitePage />,
          },
          {
            path: "theme",
            element: <SiteSettingsThemeScreen />,
          },
          {
            path: "menu",
            element: <SiteSettingsMenuPage />,
          },
          {
            path: "fonts-and-colors",
            element: <SiteSettingsFontsAndColorsPage />,
          },
          {
            path: "delete",
            element: <SiteSettingsDeleteSitePage />,
          },
          {
            path: "advanced",
            element: <SiteSettingsAdvancedPage />,
          },
        ],
      },
    ],
  },
  {
    path: "/account/*",
    element: <ManageAccountPage />,
  },
  {
    path: "/*",
    element: <Navigate replace to="/" />,
  },
];
